import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { deleteOffer, getAllOffers, updateOfferByID } from "../../api/offers";
import { Offer } from "../../models/offers";
import DeleteOfferModal from "../../components/SuperDashboard/ManageOffers/DeleteOfferModal";
import MigrateOfferModal from "../../components/SuperDashboard/ManageOffers/MigrateOfferModal";
import ManageOffersCard from "../../components/SuperDashboard/ManageOffers/ManageOffersCard";
import { deleteZipList } from "../../api/fileSystem";

export default function SuperManageOffersPage() {
    const [offers, setOffers] = useState<Offer[]>([]);
    const [isEditOpen, setEditOpen] = useState(false);
    const [editingOffer, setEditingOffer] = useState<Offer | null>(null);
    const [deletingOffer, setDeletingOffer] = useState<Offer | null>(null);
    const [migratingOffer, setMigratingOffer] = useState<Offer | null>(null);

    const handleDelete = (offer: Offer) => {
        setDeletingOffer(offer);
    }

    const handleMigrate = (offer: Offer) => {
        setMigratingOffer(offer);
    }

    const confirmDelete = async (deletingOffer: Offer) => {
        try {
            await deleteOffer(deletingOffer.id);
            await deleteZipList(deletingOffer.id);
            setOffers(prev => prev.filter(o => o.id !== deletingOffer.id));
            toast.success("Offer deleted");
        } catch (err) {
            toast.error("Failed to delete offer");
        } finally {
            setDeletingOffer(null);
        }
    }

    const confirmMigrate = async (migratingOffer: Offer, newEmail: string) => {
        try {
            await updateOfferByID({ id: migratingOffer.id, offer_creator: newEmail });
            setOffers(prev =>
                prev.map(o =>
                    o.id === migratingOffer.id ? { ...o, offer_creator: newEmail } : o
                )
            );
            toast.success("Offer migrated");
        } catch (err) {
            toast.error("Failed to migrate offer");
        } finally {
            setMigratingOffer(null);

        }
    }
    const handleEdit = (offer: Offer) => {
        setEditingOffer(offer);
        setEditOpen(true);
    };
    const handleOfferUpdated = (updatedOffer: Offer) => {
        setOffers((prev) =>
            prev.map((u) => (u.id === updatedOffer.id ? updatedOffer : u))
        );
    };
    const fetchOffers = async () => {
        try {
            const result = await getAllOffers({ page_size: 0 });
            ;
            setOffers(result);
        } catch (error: any) {
            toast.error(error?.message || "Failed to fetch Offers");
        }
    };

    useEffect(() => {
        fetchOffers();
    }, []);


    return (
        <>
            <div className="p-6 min-h-screen bg-gray-100 dark:bg-gray-900">
                <div className="flex justify-between items-center mb-6">
                    <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                        Manage Offers
                    </h1>
                </div>

                {offers.map((offer) => (
                    <ManageOffersCard
                        key={offer.id}
                        id={offer.id}
                        vertical={offer.vertical}
                        category={offer.category}
                        offer_creator={offer.offer_creator}
                        onDelete={() => handleDelete(offer)}
                        onMigrate={() => handleMigrate(offer)}


                    />
                ))}
            </div>
            {deletingOffer && (
                <DeleteOfferModal offer_id={deletingOffer.id} onClose={() => { setDeletingOffer(null); }} onConfirm={() => confirmDelete(deletingOffer)} isSupply={false} />
            )
            }
            {migratingOffer && (
                <MigrateOfferModal offer_id={migratingOffer.id} onClose={() => { setMigratingOffer(null); }} onConfirm={(email: string) => confirmMigrate(migratingOffer, email)} />
            )
            }
        </>
    );
}
